import React, { useState, useRef , forwardRef, useImperativeHandle } from "react";
import {AgGridColumn, AgGridReact} from 'ag-grid-react';
import { Button} from "@material-ui/core";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import '../styles'
import { toProperCase } from "../../../healpers/utilityFunctions";

export default forwardRef ( function Tables(props,ref) {

  const gridRef = useRef(null);
  const [gridApi, setGridApi] = useState(null);


  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  useImperativeHandle(ref, () => ({
    onBtnExport() {
      if(gridRef.current.api.getSelectedNodes().length)
        gridApi.exportDataAsCsv({onlySelected: true});
      else 
      gridApi.exportDataAsCsv();
    }
  }));

  const rowStyle = { background: 'white' };

  const EditButtonRenderer = (buttonProps) => {
    return (
      <Button
        variant="contained"
        color="primary"
        size="medium"
        style={{ textTransform: "capitalize" }}
        onClick={() => {props.openEditModel(buttonProps?.data)}}
      >
        Edit
      </Button>
    );
  };

  const DeleteButtonRenderer = (buttonProps) => {
    return (
      <Button
        variant="contained"
        color="secondary"
        size="medium"
        style={{ textTransform: "capitalize" }}
        onClick={() => props.deleteConfirmation(buttonProps?.data)}
      >
        Delete
      </Button>
    );
  };

  return (
    <div className="ag-theme-material" style={{height: 620, width: '100%'}} id="#grid-theme-wrapper">
      <AgGridReact
        ref={gridRef}
        rowData={props.tableData}
        suppressExcelExport={true}
        defaultColDef={{
          filter: 'agTextColumnFilter',
          resizable: true,
          headerComponentParams: {
            template:
              '<div class="ag-cell-label-container" role="presentation">' +
              '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
              '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
              '  </div>' +
              '</div>',
          },
        }}
        onGridReady={onGridReady}
        pagination={true}
        paginationPageSize={50}
        rowStyle={rowStyle}
        frameworkComponents={{
          editButtonRenderer: EditButtonRenderer,
          deleteButtonRenderer: DeleteButtonRenderer,
        }}
        fullWidth
        suppressDragLeaveHidesColumns={true}
        suppressRowClickSelection={true}
      >
            <AgGridColumn headerName="Name" field="name" width={250}/>
            <AgGridColumn headerName="Type" field="type" width={150} valueFormatter={properCase}/>
            {/* <AgGridColumn headerName="Report Types" field="reportTypes" width={250} valueFormatter={stringFromArray}/> */}
            <AgGridColumn headerName="Customer ASINs" field="customerASINs" width={200} valueFormatter={stringFromArray}/>
            <AgGridColumn headerName="Competitor ASINs" field="competitorASINs" width={200} valueFormatter={stringFromArray}/>
            <AgGridColumn headerName="Top Performing ASINs" field="topPerformingASINs" width={200} valueFormatter={stringFromArray}/>
            <AgGridColumn width={100} cellRenderer="editButtonRenderer" cellEditorParams={{cellEditorParams:"editButtonRenderer"}} />
            <AgGridColumn width={100} cellRenderer="deleteButtonRenderer" cellEditorParams={{cellEditorParams:"deleteButtonRenderer"}} />
      </AgGridReact>
    </div>
  );
})


const stringFromArray = (params) => params.value && params.value.map(data => data)
const properCase = (params) => params.value && toProperCase(params.value);


